import React from 'react';
import AbilityCoverPage from './AbilityCoverPage';
import AbilityOrbitVisual from './AbilityOrbitVisual';
import { testBtnPrimaryLg } from './testUiClasses';

function AbilitySuiteCover({ t, onBegin, onRestart, hasOngoingTest = false, onBack }) {
  const abilities = [
    { label: t('report.logicalReasoning'), dot: 'bg-violet-600' },
    { label: t('report.criticalThinking'), dot: 'bg-amber-600' },
    { label: t('report.verbalReasoning'), dot: 'bg-emerald-600' },
    { label: t('report.communication'), dot: 'bg-rose-600' },
    { label: t('report.quantitativeReasoning'), dot: 'bg-primary' }
  ];

  const visual = (
    <AbilityOrbitVisual
      abilities={abilities}
      count={5}
      countLabel={t('test.suiteCoverAbilityAreas', { count: 5 })}
      ariaLabel={t('test.suiteCoverAbilityAreas', { count: 5 })}
    />
  );

  return (
    <AbilityCoverPage
      title={t('test.paperMenuTitle')}
      eyebrow={t('test.suiteCoverEyebrow')}
      primaryLabel={hasOngoingTest ? t('test.resumeTest') : t('test.beginAbilityTest')}
      onPrimary={onBegin}
      restartLabel={hasOngoingTest && onRestart ? t('test.restartAbilityTest') : undefined}
      onRestart={hasOngoingTest ? onRestart : undefined}
      primaryClassName={`${testBtnPrimaryLg} px-8 py-4 text-base shadow-xl shadow-black/10 transition-all hover:-translate-y-0.5 hover:shadow-2xl focus:ring-offset-canvas`}
      afterActions={(
        <ol className="grid gap-7 text-left text-sm leading-7 text-ink-muted md:grid-cols-2 md:gap-12">
          <li className="grid grid-cols-[2.5rem_1fr] items-start gap-3">
            <span className="text-3xl font-bold leading-none tracking-tighter text-ink-subtle">
              01
            </span>
            <span>{t('test.suiteCoverRemarkOne')}</span>
          </li>
          <li className="grid grid-cols-[2.5rem_1fr] items-start gap-3">
            <span className="text-3xl font-bold leading-none tracking-tighter text-ink-subtle">
              02
            </span>
            <span>{t('test.suiteCoverRemarkTwo')}</span>
          </li>
        </ol>
      )}
      secondaryLabel={onBack ? t('test.backToChapters') : undefined}
      onSecondary={onBack}
      fullBleed
      wide
      visual={visual}
    >
      <p className="mx-auto max-w-2xl text-lg leading-8 text-ink-muted lg:mx-0 lg:text-xl lg:leading-9">
        {t('test.suiteCoverIntro')}
      </p>
    </AbilityCoverPage>
  );
}

export default AbilitySuiteCover;
